import { constants } from "../constants/redux-constants";

const initialState = false;

const NewVisitSelectedReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.NEW_VISIT_SELECTED:
      return action.payload;
    default:
      return state;
  }
};

export default NewVisitSelectedReducer;
